module.exports = "<svg viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17 26H25C25.5523 26 26 25.5523 26 25V14.8889V7C26 6.44772 25.5523 6 25 6H13.7778H7C6.44772 6 6 6.44772 6 7V14\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><circle cx=\"6\" cy=\"21\" r=\"3\" stroke=\"currentColor\" stroke-width=\"1.5\"></circle><path d=\"M9 12L6.35355 14.6464C6.15829 14.8417 5.84171 14.8417 5.64645 14.6464L3 12\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/upcut.svg
// module id = YLfu
// module chunks = 1